import axiosInstance from '../plugins/axios'
// import jwtDecode from 'jwt-decode'
import Vue from 'vue'

export function authService () {
  const login = async (data) => {
      return await axiosInstance.post(`${process.env.VUE_APP_BASE_URL_ADMIN}/login`, data)
  }

  // const decodeToken = (token) => {
  //   return jwtDecode(token)
  // }

  const setToken = (token) => {
    // const decodedToken = decodeToken(token)
    // Vue.$cookies.set('tebyanPanel', token, decodedToken.exp)
    Vue.$cookies.set('mardomNamaPanel', token, '24h')
  }

  const removeToken = () => {
    Vue.$cookies.remove('mardomNamaPanel')
  }

  const getToken = () => {
    return Vue.$cookies.get('mardomNamaPanel')
  }

  const existToken = () => {
    return Vue.$cookies.isKey('mardomNamaPanel')
  }

  return {
    login,
    setToken,
    removeToken,
    getToken,
    existToken,
  }
}
